/**
 * Gallery block — multi-image upload via FileUpload.
 */
import { Trash2, Plus, ImageIcon } from "lucide-react";
import FileUpload from "@/components/churchbuilder/FileUpload";

const inp = "w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2.5 rounded text-sm text-white";

export default function GalleryBlockEditor({ churchId, items = [], onChange }) {
  const update = (i, patch) => {
    const arr = [...items];
    arr[i] = { ...arr[i], ...patch };
    onChange(arr);
  };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, { _id: (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : Math.random().toString(36).slice(2), url: "", caption: "" }]);

  return (
    <div data-testid="block-gallery" className="luxury-card rounded-xl p-5">
      <div className="flex items-center justify-between">
        <div className="font-serif-display text-xl flex items-center gap-2"><ImageIcon size={16} className="text-[#D4AF37]" /> Gallery</div>
        <button data-testid="block-gallery-add" onClick={add} className="btn-ghost-gold text-[10px] tracking-widest uppercase px-3 py-1.5 rounded inline-flex items-center gap-1"><Plus size={11} /> Add Image</button>
      </div>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((row, i) => (
          <div key={row._id || `gal-${i}`} data-testid={`block-gal-row-${i}`} className="border border-white/5 rounded-lg p-3 bg-black/30 space-y-2">
            <FileUpload churchId={churchId} value={row.url} onChange={(url) => update(i, { url })} testid={`gal-${i}-image`} />
            <input className={inp} placeholder="Caption (optional)" value={row.caption || ""} onChange={(e) => update(i, { caption: e.target.value })} data-testid={`gal-${i}-caption`} />
            <button data-testid={`gal-${i}-remove`} onClick={() => remove(i)} className="text-red-400 text-xs tracking-widest uppercase inline-flex items-center gap-1"><Trash2 size={11} /> Remove</button>
          </div>
        ))}
        {items.length === 0 && <div className="text-xs text-neutral-500">No gallery images yet.</div>}
      </div>
    </div>
  );
}
